import React, { useState, useEffect } from "react";
import { List } from "antd";
import ExtensionListItem from "./ExtensionListItem";

const AssignExtensionList = ({
  extensions = [],
  onExtensionSelect,
  initialSelectedExtensionId = null,
}) => {
  const [selectedExtensionId, setSelectedExtensionId] = useState(initialSelectedExtensionId);

  // Update selectedExtensionId when initialSelectedExtensionId changes
  useEffect(() => {
    setSelectedExtensionId(initialSelectedExtensionId);
  }, [initialSelectedExtensionId]);

  const handleExtensionSelect = extensionId => {
    setSelectedExtensionId(extensionId);
    const selectedExtension = extensions.find(ext => ext.id === extensionId);
    if (onExtensionSelect) {
      onExtensionSelect(selectedExtension);
    }
  };

  return (
    <div>
      {/* Extensions List */}
      <List
        dataSource={extensions}
        renderItem={extension => (
          <List.Item className="!p-0 !border-0 !w-full">
            <div className="w-full">
              <ExtensionListItem
                extension={extension}
                selected={selectedExtensionId === extension.id}
                onSelect={handleExtensionSelect}
              />
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default AssignExtensionList;
